import React from 'react'
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { useSignal } from "@preact/signals-react"


export default function AlertsTableCustomToolbar({ legendElements, filterConditions, isNoAvailability }) {
	return (
		<Box sx={{
			...isNoAvailability && { visibility: "hidden" },
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			flexDirection: "column",
			mb: 1
		}}>
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "space-around", flexDirection: "row" }}>
				{!!legendElements.length && legendElements.map(({ icon, value, label, iconProps = {} }, idx) => {
					const selected = useSignal(false)
					return <Box
						key={idx}
						onClick={() => {
							filterConditions(value)
							selected.value = !selected.value
						}}
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							flexDirection: "column",
							cursor: "pointer",
							mx: 1,
							transition: "transform 0.3s ease-in-out",
							'&:hover': {
								transform: "scale(1.05)",
							}
						}}
					>
						<IconSeeker
							icon={icon}
							sx={{
								mt: 0.5,
								mb: 0,
								fontSize: 16,
								...iconProps,
								...selected.value && { color: "primary.main" },
								transition: "transform 0.3s ease-in-out",
								transform: selected.value ? "rotate(20deg)" : "rotate(0deg)",
							}}
						/>

						<Typography
							sx={{
								mt: 0,
								fontWeight: "bold",
								transition: "color 0.3s ease-in-out",
								color: selected.value ? "primary.main" : "text.primary",
								userSelect: "none"
							}}
						>
							{label}
						</Typography>
					</Box>
				})}
			</Box>
		</Box>
	)
}
